import { ICellRendererParams } from 'ag-grid-community';

import { DEFAULT_PLACEHOLDER } from 'core/constants';
import { TextLine, WarningCell } from 'core/elements';
import { WarningType } from 'core/enums';
import { QuotePartColId } from 'quotes/components/QuotePartList';
import { QuotePartHelper } from 'quotes/helpers';

export const ShipmentTypeCell = ({ data, value: shipmentType, node }: ICellRendererParams) => {
  const isGroupedByColumn = QuotePartColId.SHIPMENT_TYPE === node?.rowGroupColumn?.getColId();

  if (!shipmentType) {
    return node?.group && !isGroupedByColumn ? '' : DEFAULT_PLACEHOLDER;
  }

  return (
    <WarningCell
      content={<TextLine text={shipmentType.name} textEllipsis />}
      showWarning={QuotePartHelper.shipmentTypeWarning(data).show}
      type={WarningType.ERROR}
    />
  );
};
